import { getAuth, signInWithEmailAndPassword } from 'firebase/auth';
import { logError } from '../../../shared/reporting';
import { handleError } from './handleError';

export async function signInWithEmail(
  email: string,
  password: string,
  onError: (emailError: string, passwordError: string) => void,
  onSignedIn: () => void,
) {
  try {
    await signInWithEmailAndPassword(getAuth(), email, password);
    onSignedIn();
  } catch (error) {
    const [errorField, errorMsg] = handleError(error);

    if (!errorField) {
      logError(error);
    } else if (errorField === 'email') {
      onError(errorMsg, null);
    } else {
      onError(null, errorMsg);
    }
  }
}
